import React from 'react';
import styled from 'styled-components';
import { adminTheme } from '../styles/adminTheme';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Dialog = styled.div`
  background: white;
  border-radius: ${adminTheme.borderRadius};
  padding: 24px;
  min-width: 360px;
  max-width: 440px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${adminTheme.colors.text};
  margin-bottom: 8px;
`;

const Message = styled.p`
  font-size: 13px;
  color: ${adminTheme.colors.textSecondary};
  margin-bottom: 20px;
  line-height: 1.5;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const Btn = styled.button<{ $danger?: boolean }>`
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid ${p => p.$danger ? adminTheme.colors.danger : adminTheme.colors.border};
  background: ${p => p.$danger ? adminTheme.colors.danger : 'white'};
  color: ${p => p.$danger ? 'white' : adminTheme.colors.text};

  &:hover {
    background: ${p => p.$danger ? adminTheme.colors.dangerHover : '#f8f9fa'};
  }
`;

interface ConfirmDialogProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  danger?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirm',
  danger = false,
}) => {
  return (
    <Overlay onClick={onCancel}>
      <Dialog onClick={e => e.stopPropagation()}>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <Actions>
          <Btn onClick={onCancel}>Cancel</Btn>
          <Btn $danger={danger} onClick={onConfirm}>{confirmLabel}</Btn>
        </Actions>
      </Dialog>
    </Overlay>
  );
};
